// extracted by mini-css-extract-plugin
module.exports = {"course_card_box":"styles_course_card_box__31YSZ","course_card_box__show":"styles_course_card_box__show__RWqUD"};